import React from 'react';
import {
  Content,
  Row,
  Col,
  Title,
  Text,
  ModalLayout,
  Table2,
  Image,
  Button as Btn,
  KakaoMap,
} from 'components';
import { RentalListTable, SideMenu } from '../components';
import OrderListTable from '../components/OrderListTable/OrderListTable';
import { stringToMoneyFormat, STORE_URL, openPopup } from 'utils';
import { Button, Spin, Image as Img } from 'antd';
import equal from 'assets/equal.svg';
import remove from 'assets/remove.svg';
import more from 'assets/more.svg';
import Formatter from 'utils/Formatter';
import trackDelivery from 'utils/TrackDelivery';
import dayjs from 'dayjs';
import SHOPPING from 'assets/svg/shopping.svg';
import { useInView } from 'react-intersection-observer';

import Checked from 'assets/radio_checked.svg';
import UnChecked from 'assets/radio_unchecked.svg';

const PAYMENT_METHOD = {
  CARD: '신용카드',
  NAVER_PAY: '네이버페이',
  KAKAO_PAY: '카카오페이',
  TRANSFER: '계좌이체',
  MOBILE: '휴대폰 결제',
  JM_PAY: 'JM 페이',
};

const DELIVERY_STATUS = {
  PENDING: '상품 준비중',
  SHIPPING: '상품 배송중',
  DELIVERED: '배송 완료',
};

const PAYMENT_STATE = {
  PENDING: '결제 대기',
  COMPLETED: '결제 완료',
  CANCELLED: '결제 취소',
  FAILED: '결제 실패',
  REFUNDED: '환불 완료',
};

const MypageOrderDetailsPresenter = (props) => {
  /* ===== Props ===== */
  const {
    order,
    navigate,
    onOrderStatus,
    isLoading,
    onRegularStatus,
    selectedParcel,
    onCheckedList,
    onCheckedListAll,
    screenSize,
    card,
    onChangePaymentCard,
  } = props;

  /* ===== Variables ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 24 : 18,
      fontWeight: 700,
      color: 'var(--black-color)',
      fontFamily: 'Pretendard',
    },

    more: {
      fontSize: 16,
      fontWeight: 700,
      color: 'var(--black-color)',
      cursor: 'pointer',
    },
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 32,
      borderBottom: '2px solid var(--black-color)',
    },
    listButton: {
      fontSize: 16,
      fontWeight: 700,
      backgroundColor: 'var(--black-color)',
      color: 'var(--white-color)',
      width: 240,
      height: 64,
      borderRadius: 4,
    },
    paginationButton: {
      border: '1px solid var(--black-color)',
      color: 'var(--black-color)',
      width: 48,
      height: 48,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    section: {
      height: 92,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '32px 40px',
      fontWeight: 700,
      borderBottom: '1px solid #ddd',
    },
    columnSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      padding: '32px 40px',
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    text: {
      fontSize: 14,
    },
    lighttext: {
      fontSize: 12,
      color: 'var(--dark-gray-color)',
    },
    paytitle: {
      fontSize: 16,
      fontWeight: 700,
    },

    button: {
      width: 143,
      height: 48,
      fontSize: 16,
      fontWeight: 700,
    },

    paymentHistoryWrap: {
      padding: '20px 10px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #EEEEEE',
    },
  };

  /* ===== State ===== */
  const today = dayjs().unix();
  const [delayModal, setDelayModal] = React.useState(null);
  const [isPickupModal, setIsPickupModal] = React.useState(null);
  const [mapKey, setMapKey] = React.useState('MAP');

  const [ref, inView] = useInView();
  const [page, setPage] = React.useState(0);

  // 결제 카드 변경 모달
  const [isOpened, setIsOpened] = React.useState(null);

  /* ===== Function ===== */
  /* ===== Hooks ===== */
  /**
   * 렌탈 결제내역 무한 스크롤
   * --
   */
  React.useEffect(() => {
    if (inView) {
      setTimeout(() => setPage((prev) => ++prev), 500);
    }
  }, [inView]);

  /* ===== Render ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={0} md={6} xl={4}>
              <SideMenu />
            </Col>
            <Col x={24} md={16} xl={16}>
              <Content
                maxWidth={'100%'}
                padding={
                  screenSize >= 1200
                    ? '0 0 0 95px'
                    : screenSize >= 768
                    ? '0 0 0 20px'
                    : '0'
                }
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Title
                    style={{
                      fontSize:
                        screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
                      fontWeight: 700,
                      color: 'var(--black-color)',
                      fontFamily: 'Pretendard',
                    }}
                  >
                    주문상세
                  </Title>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid var(--black-color)',
                    marginTop: 23,
                  }}
                >
                  {order?.type !== 'RENTAL' ? (
                    order?.shop_order.map((parcel) => (
                      <OrderListTable
                        key={`order-table-${parcel.parcel_service_id}`}
                        orders={[parcel]}
                        detailText={
                          order.type !== 'STORE_PICKUP' ? '배송조회' : null
                        }
                        onDetailClick={(state) =>
                          trackDelivery(
                            state.delivery_company,
                            state.invoice_number
                          )
                        }
                        onSubmit={onOrderStatus}
                        showExpectedCycle={
                          parcel.type === 'SUBSCRIPTION' ? true : false
                        }
                      />
                    ))
                  ) : (
                    <RentalListTable
                      key={`shop-rental-order`}
                      orders={[order]}
                      detailText={'배송조회'}
                      onDetailClick={(state) =>
                        trackDelivery(
                          state?.rental?.[0]?.delivery_company,
                          state?.rental?.[0]?.invoice_number
                        )
                      }
                      onSubmit={onOrderStatus}
                    />
                  )}
                </div>

                {order?.type === 'SUBSCRIPTION' ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      alignItems: 'center',
                      marginTop: 24,
                      gap: 17,
                    }}
                  >
                    {order.parcel_service.some(
                      (parcel) => parcel.is_regular_postponed === 'N'
                    ) ? (
                      <Button
                        style={{ ...styles.button }}
                        onClick={() => setDelayModal('DELAY')}
                      >
                        배송미루기
                      </Button>
                    ) : null}

                    {order.parcel_service.some(
                      (parcel) => parcel.is_active === 'Y'
                    ) ? (
                      <Button
                        style={{ ...styles.button }}
                        onClick={() => setDelayModal('CANCEL')}
                      >
                        구독취소
                      </Button>
                    ) : null}
                  </div>
                ) : null}

                {order?.type !== 'STORE_PICKUP' ? (
                  <div
                    style={{
                      margin: '140px 0',
                    }}
                  >
                    <div
                      style={{
                        ...styles.titleLayout,
                      }}
                    >
                      <Title style={{ ...styles.title }}>배송 정보</Title>
                      <img src={more} alt="more icon" />
                    </div>

                    {/* 내용 */}
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '32px 40px',
                      }}
                    >
                      <Text style={{ fontWeight: 700 }}>
                        {order?.delivery_address.recipient_name}
                      </Text>
                      <Text style={{ margin: '4px 0' }}>
                        {order?.delivery_address.recipient_phone}
                      </Text>
                      <Text>
                        ({order?.delivery_address.recipient_postcode}){' '}
                        {order?.delivery_address.recipient_address}{' '}
                        {order?.delivery_address.recipient_address_detail}
                      </Text>
                    </div>
                    <Text
                      style={{
                        padding: '16px 40px',
                        backgroundColor: '#f4f4f4',
                      }}
                    >
                      {order?.delivery_address.request
                        ? order?.delivery_address.request
                        : '-'}
                    </Text>
                  </div>
                ) : (
                  <div
                    style={{
                      margin: '140px 0',
                    }}
                  >
                    <div
                      style={{
                        ...styles.titleLayout,
                      }}
                    >
                      <Title style={{ ...styles.title }}>픽업지 정보</Title>
                      <img src={more} alt="more icon" />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 10,
                        borderTop: '1px solid #EEEEEE',
                        paddingTop: 20,
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                          }}
                        >
                          <img
                            src={SHOPPING}
                            alt="매장"
                            style={{ width: 32 }}
                          />
                          <Text size={18} weight={700}>
                            {order?.delivery_address?.forwarding_name}
                          </Text>
                        </div>

                        <div>
                          <Text size={16} color={'var(--light-gray-color)'}>
                            {order?.delivery_address?.forwarding_address},{' '}
                            {order?.delivery_address?.forwarding_address_detail}
                          </Text>
                        </div>

                        <ul
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                          }}
                        >
                          <li
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 10,
                            }}
                          >
                            <Text weight={700}>대표연락처</Text>
                            <Text color={'#666666'}>
                              {order?.delivery_address?.phone}
                            </Text>
                          </li>
                          <li>
                            <Text size={12}>|</Text>
                          </li>

                          <li
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 10,
                            }}
                          >
                            <Text weight={700}>영업시간</Text>
                            <Text color={'#666666'}>
                              {
                                order?.delivery_address?.receive_information
                                  ?.business_hour
                              }
                            </Text>
                          </li>
                        </ul>
                      </div>

                      <div>
                        <Btn
                          style={{ borderRadius: 0 }}
                          type="secondary"
                          onClick={() =>
                            setIsPickupModal(order?.delivery_address)
                          }
                        >
                          지도보기
                        </Btn>
                      </div>
                    </div>
                  </div>
                )}

                {/* 정기배송 정보 */}
                {order?.type === 'SUBSCRIPTION' ? (
                  <div
                    style={{
                      margin: '140px 0',
                    }}
                  >
                    <div
                      style={{
                        ...styles.titleLayout,
                        justifyContent: 'space-between',
                      }}
                    >
                      <div style={{ display: 'flex', gap: 8 }}>
                        <Title style={{ ...styles.title }}>정기배송 내역</Title>
                        <img src={more} alt="more icon" />
                      </div>
                      <Button
                        onClick={() =>
                          setIsOpened({
                            type: 'SUBSCRIPTION',
                            card_id: order.parcel_service?.[0]?.card_id,
                          })
                        }
                      >
                        결제카드 변경하기
                      </Button>
                    </div>

                    {/* 내용 */}
                    {order.parcel_service.map((parcel) => {
                      const { regular_payment_info, is_active } = parcel;
                      const sortData = regular_payment_info
                        .slice()
                        .sort(
                          (a, b) => b.regular_payment_id - a.regular_payment_id
                        );

                      const dataLength =
                        is_active === 'Y'
                          ? sortData.length + 1
                          : sortData.length;

                      const splitCycle = parcel.regular_cycle.split('-');

                      return (
                        <div
                          key={`parcel-${parcel.parcel_service_id}`}
                          style={{ borderBottom: '1px solid #DDDDDD' }}
                        >
                          {new Array(dataLength).fill(null).map((_, _index) => {
                            const isExist =
                              is_active === 'N'
                                ? sortData?.[_index]
                                : _index > 0
                                ? sortData?.[_index - 1]
                                : null;

                            return (
                              <div
                                key={`regular-${_index}-${parcel.parcel_service_id}`}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  padding: '32px 40px',
                                  gap: 15,
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      width: '5%',
                                    }}
                                  >
                                    <Text weight={700}>
                                      {dataLength - _index}
                                      <span>회차</span>
                                    </Text>
                                    {is_active === 'N' && _index === 0 ? (
                                      <Text size={12} color={'#D33444'}>
                                        구독취소
                                      </Text>
                                    ) : null}
                                  </div>
                                  <div
                                    style={{
                                      width: '15%',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    <Text weight={500}>
                                      {isExist ? '결제일' : '결제 예정일'}
                                    </Text>
                                    <Text size={12} color={'#999999'}>
                                      {isExist
                                        ? Formatter.unixToDate(
                                            isExist.payment_date,
                                            'YYYY.MM.DD'
                                          )
                                        : Formatter.unixToDate(
                                            parcel.regular_updated_at,
                                            'YYYY.MM.DD'
                                          )}
                                    </Text>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      flexDirection: 'column',
                                      width: '50%',
                                      gap: 15,
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                      }}
                                    >
                                      <div style={{ width: '80%' }}>
                                        <Text>
                                          {parcel.product.product_name}
                                        </Text>
                                        <Text size={14} color={'#666666'}>
                                          {parcel.product.product_option
                                            ? parcel.product.product_option
                                                .map((cur) =>
                                                  cur.option
                                                    .map((op) => op.option_name)
                                                    .join(' / ')
                                                )
                                                .join(' / ')
                                            : ''}
                                        </Text>
                                      </div>
                                      <div
                                        style={{
                                          width: '20%',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <Text>{parcel.num}개</Text>
                                        <Text>
                                          {isExist
                                            ? stringToMoneyFormat(
                                                isExist.price,
                                                '원'
                                              )
                                            : stringToMoneyFormat(
                                                sortData[0].price,
                                                '원'
                                              )}
                                        </Text>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      width: '10%',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    {!isExist &&
                                    parcel.is_regular_postponed === 'Y' ? (
                                      <Text>배송미루기</Text>
                                    ) : (
                                      <React.Fragment>
                                        <Text>배송주기</Text>
                                        <Text>
                                          {splitCycle[0]}
                                          {splitCycle[1] === 'W'
                                            ? '주'
                                            : '개월'}
                                        </Text>
                                      </React.Fragment>
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      width: '10%',
                                      textAlign: 'center',
                                    }}
                                  >
                                    <Text>
                                      {isExist
                                        ? isExist.purchase_status === 'REFUNDED'
                                          ? '환불/취소'
                                          : DELIVERY_STATUS[
                                              isExist.delivery_status
                                            ]
                                        : ''}
                                    </Text>
                                    {isExist &&
                                    isExist.purchase_status === 'REFUNDED' ? (
                                      <Text size={12} color={'#999999'}>
                                        {Formatter.unixToDate(
                                          parcel?.refund?.created_at,
                                          'YYYY.MM.DD'
                                        )}
                                      </Text>
                                    ) : isExist?.delivery_status ===
                                      'DELIVERED' ? (
                                      <Text size={12} color={'#999999'}>
                                        {Formatter.unixToDate(
                                          isExist.delivery_date,
                                          'YYYY.MM.DD'
                                        )}
                                      </Text>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                ) : null}

                {/* 결제정보 */}
                {order?.type !== 'RENTAL' ? (
                  <div
                    style={{
                      margin: '140px 0',
                    }}
                  >
                    <div
                      style={{
                        ...styles.titleLayout,
                      }}
                    >
                      <Title style={{ ...styles.title }}>결제 정보</Title>
                      <img src={more} alt="more icon" />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        borderBottom: '1px solid #ddd',
                        flexDirection: screenSize >= 768 ? 'unset' : 'column',
                      }}
                    >
                      {/* 주문금액 */}
                      <div
                        style={{
                          ...styles.container,
                          width: screenSize >= 768 ? '30.71%' : '100%',
                          borderRight:
                            screenSize >= 768 ? '1px solid #ddd' : 'none',
                          borderBottom:
                            screenSize >= 768 ? 'none' : '1px solid #ddd',
                        }}
                      >
                        <div
                          style={{
                            ...styles.section,
                            borderBottom: '1px solid #ddd',
                            position: 'relative',
                          }}
                        >
                          <img
                            src={remove}
                            alt="remove icon"
                            style={{
                              width: 24,
                              position: 'absolute',
                              top: '50%',
                              right: '-12px',
                              transform: 'translateY(-50%)',
                              display: screenSize >= 768 ? 'block' : 'none',
                            }}
                          />
                          <span style={styles.paytitle}>주문금액</span>
                          <Text style={styles.paytitle}>
                            {stringToMoneyFormat(
                              order?.total_product_price +
                                order?.final_delivery_price
                            )}
                            <span>원</span>
                          </Text>
                        </div>
                        <div style={styles.columnSection}>
                          <div style={styles.row}>
                            <span style={styles.text}>상품금액</span>
                            <Text style={styles.text}>
                              {stringToMoneyFormat(order?.total_product_price)}
                              <span>원</span>
                            </Text>
                          </div>
                          <div style={styles.row}>
                            <span style={styles.text}>배송비</span>
                            <Text style={styles.text}>
                              {stringToMoneyFormat(order?.final_delivery_price)}
                              <span>원</span>
                            </Text>
                          </div>
                        </div>
                      </div>
                      {/* 주문금액 끝 */}
                      {/* 할인금액 */}
                      <div
                        style={{
                          ...styles.container,
                          width: screenSize >= 768 ? '30.71%' : '100%',
                          borderRight:
                            screenSize >= 768 ? '1px solid #ddd' : 'none',
                          borderBottom:
                            screenSize >= 768 ? 'none' : '1px solid #ddd',
                        }}
                      >
                        <div
                          style={{ ...styles.section, position: 'relative' }}
                        >
                          <img
                            src={equal}
                            alt="equal icon"
                            style={{
                              width: 24,
                              position: 'absolute',
                              top: '50%',
                              right: '-12px',
                              transform: 'translateY(-50%)',
                              display: screenSize >= 768 ? 'block' : 'none',
                            }}
                          />
                          <span style={styles.paytitle}>할인금액</span>
                          <Text style={styles.paytitle}>
                            {stringToMoneyFormat(
                              order?.final_discount + order?.use_point
                            )}
                            <span>원</span>
                          </Text>
                        </div>
                        <div style={styles.columnSection}>
                          <div style={styles.row}>
                            <span style={styles.text}>포인트</span>
                            <Text style={styles.text}>
                              {stringToMoneyFormat(order?.use_point)}
                              <span>원</span>
                            </Text>
                          </div>
                          <div style={styles.row}>
                            <span style={styles.text}>할인</span>
                            <Text style={styles.text}>
                              -
                              {stringToMoneyFormat(
                                order?.promotion_discount_price
                              )}
                              <span>원</span>
                            </Text>
                          </div>
                          <div style={styles.row}>
                            <span style={styles.text}>쿠폰</span>
                            <Text style={styles.text}>
                              -
                              {stringToMoneyFormat(
                                order?.coupon_discount_price
                              )}
                              <span>원</span>
                            </Text>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 4,
                            }}
                          >
                            {order?.coupon_info && order?.coupon_info.length
                              ? order?.coupon_info.map((coupon, _index) => (
                                  <div
                                    key={`coupon-${_index}`}
                                    style={styles.row}
                                  >
                                    <Text style={styles.lighttext}>
                                      - {coupon.policy_coupon.coupon_name}
                                    </Text>
                                    <Text style={styles.lighttext}>
                                      {stringToMoneyFormat(
                                        coupon.discount_price
                                      )}
                                      <span>원</span>
                                    </Text>
                                  </div>
                                ))
                              : null}
                          </div>
                        </div>
                      </div>
                      {/* 할인금액 끝 */}
                      {/* 결제금액 */}
                      <div
                        style={{
                          ...styles.container,
                          width: screenSize >= 768 ? '38.48%' : '100%',
                        }}
                      >
                        <div style={styles.section}>
                          <span style={styles.paytitle}>결제금액</span>
                          <Text
                            style={{
                              ...styles.paytitle,
                              color: 'var(--red-secondary-color)',
                              fontSize: 18,
                            }}
                          >
                            {stringToMoneyFormat(order?.final_price)}
                            <span>원</span>
                          </Text>
                        </div>
                        <div style={styles.columnSection}>
                          <div style={styles.row}>
                            <span style={styles.text}>
                              {PAYMENT_METHOD[order?.payment_method]}
                            </span>
                            <Text style={styles.text}>
                              {stringToMoneyFormat(order?.final_price)}
                              <span>원</span>
                            </Text>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 4,
                            }}
                          >
                            <div style={styles.row}>
                              <span style={styles.lighttext}>결제일시</span>
                              <Text style={styles.lighttext}>
                                {Formatter.unixToDate(
                                  order?.payment_completion_date,
                                  'YYYY.MM.DD HH:mm'
                                )}
                              </Text>
                            </div>
                            <div style={styles.row}>
                              <span style={styles.lighttext}>적립혜택</span>
                              <Text style={styles.lighttext}>
                                <span>+</span>
                                {stringToMoneyFormat(
                                  order?.total_reserve_price
                                )}
                              </Text>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* 결제금액 끝 */}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      margin: '140px 0',
                    }}
                  >
                    <div
                      style={{
                        ...styles.titleLayout,
                        justifyContent: 'space-between',
                      }}
                    >
                      <div style={{ display: 'flex', gap: 8 }}>
                        <Title style={{ ...styles.title }}>결제 내역</Title>
                        <img src={more} alt="more icon" />
                      </div>
                      <Button
                        onClick={() =>
                          setIsOpened({
                            type: 'RENTAL',
                            card_id: order.rental?.[0]?.card_id,
                          })
                        }
                      >
                        결제카드 변경하기
                      </Button>
                    </div>

                    <div style={{ maxHeight: 500, overflowY: 'scroll' }}>
                      {order?.rental?.[0]?.rental_payment_info
                        ?.slice()
                        ?.sort(
                          (a, b) => b?.rental_payment_id - a?.rental_payment_id
                        )
                        ?.slice(0, page * 5)
                        ?.map((payment) => (
                          <div
                            key={`payment-${payment?.rental_payment_id}`}
                            style={{ ...styles.paymentHistoryWrap }}
                          >
                            <div style={{ display: 'flex', gap: 12 }}>
                              <div>
                                <Text weight={700}>
                                  {payment?.rental_payment_id} 회차
                                </Text>
                              </div>
                              <div>
                                <Text weight={700}>
                                  {payment?.payment_info?.issuerCardType}{' '}
                                  {payment?.payment_info?.issuerCardName}
                                </Text>
                                <Text
                                  size={14}
                                  color={'var(--light-gray-color)'}
                                >
                                  {payment?.payment_info?.cardNumb}
                                </Text>

                                <div
                                  style={{
                                    display: 'flex',
                                    gap: 4,
                                    marginTop: 4,
                                  }}
                                >
                                  <Text weight={400}>결제금액: </Text>
                                  <Text weight={700}>
                                    {stringToMoneyFormat(payment?.price, '원')}
                                  </Text>
                                </div>
                              </div>
                            </div>

                            <div>
                              <Text size={18} weight={700}>
                                {PAYMENT_STATE[payment?.payment_state]}
                              </Text>
                              <Text size={14} color={'var(--light-gray-color)'}>
                                {Formatter.unixToDate(
                                  payment?.payment_date,
                                  'YYYY.MM.DD'
                                )}
                              </Text>
                            </div>
                          </div>
                        ))}
                      <div ref={ref}></div>
                    </div>
                  </div>
                )}

                {/* 결제정보 끝 */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    onClick={() => navigate('/mypage/order')}
                    style={styles.listButton}
                  >
                    목록
                  </Button>
                </div>
              </Content>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>
        </Content>
      </Spin>

      {/* 배송미루기/구독취소 */}
      <ModalLayout
        open={!!delayModal}
        onCancel={() => setDelayModal(null)}
        // width={''}
        centered
        styles={{
          content: {
            borderRadius: 8,
          },
        }}
        title={`정기배송 ${delayModal === 'DELAY' ? '미루기' : '구독취소'}`}
        footer={
          <Button
            onClick={async () => {
              const res = await onRegularStatus(delayModal);

              if (res) {
                setDelayModal(null);
              }
            }}
          >
            {delayModal === 'DELAY' ? '미루기' : '구독취소'}
          </Button>
        }
      >
        <Content maxWidth={'100%'} padding={0}>
          <Table2
            data={order?.parcel_service
              ?.filter((parcel) =>
                delayModal === 'DELAY'
                  ? parcel.is_regular_postponed === 'N' &&
                    parcel.is_active === 'Y'
                  : parcel.is_active === 'Y'
              )
              ?.map((parcel) => {
                const standard =
                  delayModal === 'DELAY'
                    ? parcel?.product?.regular_information
                        ?.regular_postponed_deadline ?? 3
                    : parcel?.product?.regular_information?.cancel_deadline ??
                      3;

                const isCancelAble =
                  dayjs
                    .unix(parcel?.regular_updated_at)
                    .diff(dayjs.unix(today), 'day') < standard;

                return {
                  key: parcel.parcel_service_id,
                  disabled: isCancelAble,
                  ...parcel,
                };
              })}
            isChecked
            checkedAll={
              selectedParcel?.length ===
              order?.parcel_service?.filter((parcel) =>
                delayModal === 'DELAY'
                  ? parcel.is_regular_postponed === 'N' &&
                    parcel.is_active === 'Y'
                  : parcel.is_active === 'Y'
              )?.length
            }
            checkedList={selectedParcel}
            onCheckedAll={(d) => onCheckedListAll(d)}
            onChecked={(_, d) => onCheckedList(d)}
            columns={[
              {
                title: '상품정보',
                key: 'product_name',
                render: (_, state) => (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 24,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: 24,
                        flex: 1,
                      }}
                    >
                      <Image
                        src={state.product.thumbnail}
                        alt={state.product.product_name}
                        width={90}
                        height={111}
                      />
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'baseline',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Text
                          size={14}
                          weight={700}
                          style={{ lineHeight: '180%' }}
                        >
                          {state.product.shop_information_name}
                        </Text>
                        <Text size={16} style={{ lineHeight: '180%' }}>
                          {state.product.product_name}
                        </Text>
                        {state.option ? (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              width: '100%',
                              gap: 10,
                            }}
                          >
                            <Text size={14} color={'var(--light-gray-color)'}>
                              {state.product.product_option
                                ? state.product.product_option
                                    .map((cur) =>
                                      cur.option
                                        .map((op) => op.option_name)
                                        .join(' / ')
                                    )
                                    .join(' / ')
                                : null}
                            </Text>
                          </div>
                        ) : null}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            gap: 5,
                          }}
                        >
                          <Text size={14} color={'var(--light-gray-color)'}>
                            배송주기
                          </Text>
                          <Text size={14} color={'#D33444'}>
                            {state.regular_cycle.split('-')[0]}
                            {state.regular_cycle.split('-')[1] === 'W'
                              ? '주'
                              : '개월'}
                          </Text>
                        </div>
                      </div>
                    </div>
                    <div>
                      <Text size={14}>
                        {delayModal === 'DELAY'
                          ? '미루기 가능일'
                          : '취소 가능일'}
                      </Text>
                      <Text size={12} color={'var(--light-gray-color)'}>
                        {Formatter.unixToDate(
                          dayjs
                            .unix(state?.regular_updated_at)
                            .subtract(
                              delayModal === 'DELAY'
                                ? state?.product?.regular_information
                                    ?.regular_postponed_deadline ?? 3
                                : state?.product?.regular_information
                                    ?.cancel_deadline ?? 3,
                              'day'
                            )
                            .unix(),
                          'YYYY.MM.DD'
                        )}
                      </Text>
                    </div>
                  </div>
                ),
                style: {
                  padding: 21,
                },
              },
            ]}
          />
        </Content>
      </ModalLayout>

      {/* 스토어픽업 지도 */}
      <ModalLayout
        open={!!isPickupModal}
        onCancel={() => setIsPickupModal(null)}
        width={'30%'}
        centered
        title={isPickupModal?.forwarding_name}
        styles={{
          content: {
            padding: 0,
          },
          header: {
            padding: '12px 24px',
            borderBottom: '1px solid #DDDDDD',
          },
        }}
      >
        <Content maxWidth={'100%'} padding={0}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={'12px 21px'}>
                <div>
                  <ul style={{ display: 'flex' }}>
                    <li
                      style={{
                        padding: '12px 24px',
                        background: mapKey === 'MAP' ? '#111111' : '#FFFFFF',
                        border: '1px solid #111111',
                        cursor: 'pointer',
                      }}
                      onClick={() => setMapKey('MAP')}
                    >
                      <Text color={mapKey === 'MAP' ? '#FFFFFF' : '#111111'}>
                        지도
                      </Text>
                    </li>
                    {isPickupModal?.receive_information?.pickup_location_map ? (
                      <li
                        style={{
                          padding: '12px 24px',
                          background:
                            mapKey === 'ROUGH' ? '#111111' : '#FFFFFF',
                          border: '1px solid #111111',
                          cursor: 'pointer',
                        }}
                        onClick={() => setMapKey('ROUGH')}
                      >
                        <Text
                          color={mapKey === 'ROUGH' ? '#FFFFFF' : '#111111'}
                        >
                          약도
                        </Text>
                      </li>
                    ) : null}
                  </ul>
                  <div style={{ border: '1px solid #111111' }}>
                    {mapKey === 'MAP' ? (
                      <KakaoMap
                        name={isPickupModal?.forwarding_name}
                        address={`${isPickupModal?.forwarding_address}`}
                        width={'100%'}
                        height={340}
                      />
                    ) : (
                      <Img
                        src={`${STORE_URL}/${isPickupModal?.receive_information?.pickup_location_map}`}
                        width={'100%'}
                        height={340}
                        style={{ objectFit: 'contain' }}
                      />
                    )}
                  </div>

                  <ul
                    style={{
                      marginTop: 20,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 10,
                    }}
                  >
                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          영업시간
                        </Text>
                      </div>
                      <div>
                        <Text size={14}>
                          {isPickupModal?.receive_information?.business_hour}
                        </Text>
                      </div>
                    </li>

                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          전화
                        </Text>
                      </div>
                      <div>
                        <Text size={14}>{isPickupModal?.phone}</Text>
                      </div>
                    </li>

                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          주소
                        </Text>
                      </div>
                      <div>
                        <Text size={14}>
                          {isPickupModal?.forwarding_address},{' '}
                          {isPickupModal?.forwarding_address_detail}
                        </Text>
                      </div>
                    </li>

                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          담당자
                        </Text>
                      </div>
                      <div>
                        <Text size={14}>
                          {isPickupModal?.receive_information?.manager_name}
                        </Text>
                      </div>
                    </li>

                    {isPickupModal?.receive_information
                      ?.pickup_available_date ? (
                      <li style={{ display: 'flex' }}>
                        <div style={{ width: 80 }}>
                          <Text size={14} weight={700}>
                            수령 가능일
                          </Text>
                        </div>
                        <div>
                          <Text size={14}>
                            {isPickupModal?.receive_information
                              ?.pickup_available_date === 0
                              ? '당일수령가능'
                              : `주문 완료 시점부터 ${isPickupModal?.receive_information?.pickup_available_date}일 부터 수령 가능일자가 표시됩니다.`}
                          </Text>
                        </div>
                      </li>
                    ) : null}

                    <li style={{ display: 'flex' }}>
                      <div style={{ width: 80 }}>
                        <Text size={14} weight={700}>
                          수령지 안내
                        </Text>
                      </div>
                      <div>
                        <Text size={14}>
                          {
                            isPickupModal?.receive_information
                              ?.pickup_instruction
                          }
                        </Text>
                      </div>
                    </li>
                  </ul>
                </div>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* 결제카드 변경 */}
      <ModalLayout
        open={!!isOpened}
        onCancel={() => setIsOpened(null)}
        centered
        styles={{
          content: {
            borderRadius: 8,
          },
        }}
        width={500}
        closable
        title={`결제카드 변경`}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={() =>
                openPopup(
                  `/common/card/register?type=${isOpened.type.toLocaleLowerCase()}`
                )
              }
            >
              카드등록
            </Button>
            <Button
              type="primary"
              onClick={async () => {
                const res = await onChangePaymentCard(isOpened);

                if (res) {
                  setIsOpened(null);
                }
              }}
            >
              변경하기
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={0}>
          <Row>
            <Col x={24}>
              <Content
                maxWidth={'100%'}
                padding={0}
                style={{ display: 'flex', flexDirection: 'column', gap: 24 }}
              >
                {isOpened
                  ? card[isOpened.type].map((_item, _index) => (
                      <div
                        key={`card-${_item.card_id}-${_index}`}
                        style={{
                          display: 'flex',
                          alignItems: 'stretch',
                          gap: 12,
                        }}
                        onClick={() =>
                          setIsOpened((prev) => ({
                            ...prev,
                            card_id: _item.card_id,
                          }))
                        }
                      >
                        <div style={{ cursor: 'pointer' }}>
                          <img
                            src={
                              isOpened.card_id === _item.card_id
                                ? Checked
                                : UnChecked
                            }
                            alt="선택"
                            width={15}
                            height={15}
                          />
                        </div>
                        <div>
                          <Text weight={700}>{_item.card_company}</Text>
                          <Text size={14} color={'var(--light-gray-color)'}>
                            {_item.card_number} | {_item.card_validity}
                          </Text>
                        </div>
                      </div>
                    ))
                  : null}
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </React.Fragment>
  );
};

export default MypageOrderDetailsPresenter;
